export default __webpack_public_path__ + "static/media/Tick Mark.67f686d4.svg";